import React from 'react';
import { Form, Select, Checkbox } from 'antd';
import { FormInstance } from 'antd/es/form';
import FormSection from '../FormSection';
import CurvDown from '../svg/CurvDown';

const { Option } = Select;

interface SexualHarassmentActionsProps {
  form: FormInstance;
}

const SexualHarassmentActions: React.FC<SexualHarassmentActionsProps> = ({ form }) => {
  const yesNoOptions = ['Yes', 'No'];

  const whereConductOptions = [
    'Private office',
    'Work area',
    'Meeting room',
    'Public area',
    'Multiple locations'
  ];

  const bodyPartOptions = [
    'Arm', 'Hand', 'Shoulder', 'Back', 'Leg', 'Face', 'Hair', 'Other'
  ];

  const harassmentActions = [
    'Repeated suggestive comments about specific parts of your or their own body',
    'Repeated suggestive words about you to others',
    'Repeated suggestive comments about your or their own clothes',
    'Repeated obscene gestures',
    'Repeatedly touched you over your objections',
    'Repeated comments regarding his or her sex life',
    'Repeatedly asked you for dates over your objections',
    'Repeated disrobing in front of you',
    'Repeated statements that you could advance in your job if you cooperated in an intimate relationship',
    'Repeated statements that keeping your job depended on your cooperation in an intimate relationship',
    'Repeated statements that other terms or benefits of your job depended on your cooperation in an intimate relationship'
  ];

  const actionsWatch = Form.useWatch(['sexual_harassment_info', 'harassment_actions'], form) || [];

  // Logic to check if any action is selected
  const hasActionsSelected = Array.isArray(actionsWatch) && actionsWatch.length > 0;

  const isTouched = Array.isArray(actionsWatch) && actionsWatch.some(
    (item: any) => (typeof item === 'object' && item !== null ? item.action_type : item) === 'Repeatedly touched you over your objections'
  );

  return (
    <div className="flex flex-col w-full h-full sexual-harassment-actions-container mb-[31px] md:mb-0">
      <style>
        {`
          .sexual-harassment-actions-container .ant-form-item-label {
            min-height: 58px !important;
            margin-bottom: 8px !important;
            display: flex !important;
            align-items: flex-end !important;
          }
          @media (max-width: 767px) {
            .sexual-harassment-actions-container .ant-form-item-label {
              min-height: unset !important;
              margin-bottom: 0px !important;
              display: block !important;
            }
          }
          .sexual-harassment-actions-container .ant-select-selector {
            padding-left: 19px !important;
            padding-right: 19px !important;
          }
          .custom-checkbox-group .ant-checkbox-inner {
            width: 22px !important;
            height: 22px !important;
            background-color: #555D6740 !important;
            border-radius: 5px !important;
            border: none !important;
            box-shadow: none !important;
          }
          .custom-checkbox-group .ant-checkbox-checked .ant-checkbox-inner {
            background-color: #555D6740 !important;
            border: none !important;
          }
          .custom-checkbox-group .ant-checkbox-checked .ant-checkbox-inner::after {
            width: 7px !important;
            height: 10px !important;
            border-color: #1F2A37 !important;
            transform: rotate(45deg) scale(1.1) translate(-50%, -50%);
            left: 25%;
            top: 45%;
          }
          .custom-checkbox-group .ant-checkbox-wrapper {
             display: flex;
             align-items: center;
          }
          .custom-checkbox-group .ant-checkbox {
             top: 0;
             margin-right: 12px !important;
          }
          @media (max-width: 767px) {
            .custom-checkbox-group .ant-checkbox-inner {
              width: 16px !important;
              height: 16px !important;
              border-radius: 4px !important;
            }
            .custom-checkbox-group .ant-checkbox-checked .ant-checkbox-inner::after {
              width: 5px !important;
              height: 8px !important;
            }
          }
          .custom-checkbox-group .ant-checkbox-wrapper:hover .ant-checkbox-inner,
          .custom-checkbox-group .ant-checkbox:hover .ant-checkbox-inner,
          .custom-checkbox-group .ant-checkbox-input:focus + .ant-checkbox-inner {
            border: none !important;
            box-shadow: none !important;
          }
          .custom-checkbox-group .ant-checkbox-wrapper:active .ant-checkbox-inner,
          .custom-checkbox-group .ant-checkbox:active .ant-checkbox-inner {
            border: none !important;
          }
        `}
      </style>
      <FormSection title="Sexual Harassment Actions" columns={1}>
        <div className="flex flex-col gap-0 w-full">
          {/* Instruction */}
          <h3 className="font-['Lexend',sans-serif] text-[16px] md:text-[18px] font-medium text-[#1F2A37] mb-[16px]">
            Select all that apply to your harassment
          </h3>

          {/* Checkboxes Container */}
          <div className="border border-[#1F2A3738] rounded-[8px] p-6 md:py-[28px] md:px-[31px] mb-[41px] md:mb-[64px] w-full md:w-full">
            <Form.Item
              name={['sexual_harassment_info', 'harassment_actions']}
              className="mb-0 custom-checkbox-group"
              getValueProps={(value) => {
                if (Array.isArray(value)) {
                  return {
                    value: value.map((item: any) => {
                      if (typeof item === 'object' && item !== null && 'action_type' in item) {
                        return item.action_type;
                      }
                      return item;
                    }),
                  };
                }
                return { value: [] };
              }}
            >
              <Checkbox.Group
                className="w-full"
                onChange={(checkedValues) => {
                  const touchedAction = 'Repeatedly touched you over your objections';
                  if (!checkedValues.includes(touchedAction)) {
                    form.setFieldValue(['sexual_harassment_info', 'what_part_of_body_touched'], undefined);
                  }
                }}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-[14px] gap-y-[22px]">
                  {harassmentActions.map((action, index) => (
                    <div key={index} className="flex items-start">
                      <Checkbox
                        value={action}
                        className="font-['Lexend',sans-serif] text-[14px] md:text-[14px] text-[#555D67] leading-[21px] font-light "
                      >
                        {action}
                      </Checkbox>
                    </div>
                  ))}
                </div>
              </Checkbox.Group>
            </Form.Item>
          </div>

          {/* Bottom Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-[60px] gap-y-[16px] w-full md:w-[94%]">
            <Form.Item
              label="Where did the offensive conduct take place?"
              name={['sexual_harassment_info', 'where_conduct_took_place']}
              className="mb-0"
            >
              <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
                {whereConductOptions.map(option => (
                  <Option key={option} value={option}>{option}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Was anyone else present ?"
              name={['sexual_harassment_info', 'was_anyone_else_present']}
              className="mb-0"
            >
              <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
                {yesNoOptions.map(option => (
                  <Option key={option} value={option}>{option}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="What part of your body was touched?"
              name={['sexual_harassment_info', 'what_part_of_body_touched']}
              className={`mb-0 transition-opacity duration-300 ${!isTouched ? 'opacity-50' : 'opacity-100'}`}
            >
              <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />} disabled={!isTouched}>
                {bodyPartOptions.map(option => (
                  <Option key={option} value={option}>{option}</Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </div>
      </FormSection>
    </div>
  );
};

export default SexualHarassmentActions;
